/**
 * AdminProtectedRoute Component
 *
 * Convenience component for admin-only routes.
 * Redirects to "/" if user is not an admin.
 */

import ProtectedRoute from "../../common/components/auth/ProtectedRoute";

const AdminProtectedRoute = () => {
  return <ProtectedRoute requiredRole="admin" redirectTo="/" />;
};

export default AdminProtectedRoute;
